import { render, staticRenderFns } from "./filter-footer.vue?vue&type=template&id=4863ecaf&scoped=true&"
import script from "./filter-footer.vue?vue&type=script&lang=js&"
export * from "./filter-footer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4863ecaf",
  null
  
)

export default component.exports